export default __webpack_public_path__ + "static/media/anon_person.db4da89c.jpg";